/*-----------------------------------------------------------------
- Enterprise
-----------------------------------------------------------------*/
export default {
    title: 'Enterprise',
};
